// Shared formatting helpers for the Interview Recordings module (table + details modal).

// duration_seconds is not reliably populated on the recording record, so the
// display duration is derived from the recording's own start/end timestamps.
export function computeDurationSeconds(recording) {
  if (!recording) return null;

  const startedAt = recording.started_at ? new Date(recording.started_at).getTime() : NaN;
  if (!Number.isFinite(startedAt)) return null;

  const endedAt = recording.ended_at ? new Date(recording.ended_at).getTime() : NaN;
  const completedAt = recording.completed_at ? new Date(recording.completed_at).getTime() : NaN;
  const endTime = Number.isFinite(endedAt) ? endedAt : completedAt;
  if (!Number.isFinite(endTime)) return null;

  const seconds = Math.round((endTime - startedAt) / 1000);
  return seconds >= 0 ? seconds : null;
}

export function formatDuration(seconds) {
  const n = Number(seconds);
  if (!Number.isFinite(n) || n < 0) return '—';

  const h = Math.floor(n / 3600);
  const m = Math.floor((n % 3600) / 60);
  const s = Math.floor(n % 60);

  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m ${String(s).padStart(2, '0')}s`;
  if (m > 0) return `${m}m ${String(s).padStart(2, '0')}s`;
  return `${s}s`;
}

// file_size is a Postgres BIGINT, which the backend/driver returns as a
// string over JSON — coerce with Number() rather than Number.isFinite(bytes)
// directly, which rejects numeric strings.
export function formatFileSize(bytes) {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n < 0) return '—';
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
